import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const isRobot = (): boolean => getGlobalProperty("isRobot", false);
